export default __webpack_public_path__ + "static/media/demoMapSmall.4488685f.svg";